export default "__VITE_ASSET__tAduFQ9J__"